import { Folder } from '../types/GraphqlTypes';
import { getValueFromEnum } from './getValueFromEnum';

// TODO: Shared with SLW in satellite-components
export default (folder: string | null): Folder => {
  if (folder === 'REPORTED') {
    return Folder.Spam;
  } else {
    return getValueFromEnum(folder, Folder) || Folder.Inbox;
  }
};
